export const getStrapiImageUrl = (url: string) => {
    return `${process.env.NEXT_PUBLIC_STRAPI_IMAGE_BASE_URL}${url}`;
};
